import { OrderStatusType, PaymentMethodType } from "../order/types";
import { DataImportantStatusEnum } from "../user/types";

export interface IDashboard {
  userCount: number;
  previousUserCount: number;
  orderCount: number;
  previousOrderCount: number;
  totalPayment: number;
  previousTotalPayment: number;
}
export interface IChartData {
  date: string[];
  user: number[];
  order: number[];
  payment: number[];
}
export enum DateFilterTypeEnum {
  NOTHING = -1,
  ALL = 0,
  TODAY = 1,
  WEEK = 7,
  MONTH = 30,
  YEAR = 365,
}

export interface IData {
  _id: string;
  name: string;
  nameJp: string;
  email: string;
  mobile: string;
  orderId: string;
  payment_id: string;
  payment_status: string;
  subTotal: number;
  totalShipmentCapacity: number;
  shipmentCharges: number;
  totalPrice: number;
  taxAmount: number;
  paymentMethod: PaymentMethodType;
  stateId: string;
  state: string;
  status: OrderStatusType;
  importantStatus: DataImportantStatusEnum;
  createdAt: string;
  updatedAt: string;
  invoiceId: string;
}
export interface DashboardState {
  DashboardFormData: IDashboard;
  filterValue: DateFilterTypeEnum;
  startDate: Date | string;
  endDate: Date | string;
  chartData: IChartData;

}
export type InitialDashboardState = DashboardState;
